var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"about-sub"},[_c('tabs'),_c('h1',{domProps:{"textContent":_vm._s(_vm.$t('about.career'))}}),_c('div',{staticClass:"about-sub__bd"},_vm._l((_vm.article.data),function(item){return _c('div',{key:item.id,staticClass:"about-sub__article"},[_c('article-item',{attrs:{"item-data":item}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }